import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { about, labels, nav } from '../data/content';
import Section from './Section';
import Rich from './Rich';
import { LABEL } from './styles';

export default function About() {
  const { t } = useLanguage();

  return (
    <Section id="about" title={t(nav.about)}>
      <div className="mb-14 max-w-3xl space-y-4">
        <Rich paragraphs text={t(about.story)} className="text-pretty leading-relaxed text-stone-700" />
      </div>

      <div className="grid gap-14 md:grid-cols-2">
        <div>
          <h3 className={`${LABEL} mb-6`}>{t(labels.education)}</h3>
          <ol className="space-y-8">
            {about.education.map((e) => (
              <li key={e.period}>
                <p className="text-xs tabular-nums text-stone-500">{e.period}</p>
                <p className="mt-1 font-semibold">{t(e.name)}</p>
                <p className="text-sm text-stone-600">{t(e.note)}</p>
              </li>
            ))}
          </ol>
        </div>
        <div>
          <h3 className={LABEL}>{t(labels.certifications)}</h3>
          <ul className="divide-y divide-stone-200">
            {about.certifications.map((c) => (
              <li key={c.note} className="flex items-baseline justify-between gap-4 py-3">
                <p className="min-w-0">
                  <span className="font-medium">{t(c.name)}</span>
                  <span className="ml-2 text-sm text-stone-500">{c.note}</span>
                </p>
                <p className="shrink-0 text-xs tabular-nums text-stone-500">{c.date}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}
